import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices/DomainServicesContext";
import {
  type SessionRecord,
  type UpdateSessionRequest,
} from "@/shared/domain/sessions";

import { sessionQueryKeys } from "./sessionQueryKeys";

export interface UseUpdateSessionVariables {
  sessionId: string;
  /** Required when the caller belongs to more than one org. */
  resourceOwnerId: string;
  updates: UpdateSessionRequest;
}

export function useUpdateSession() {
  const { sessionService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<SessionRecord, Error, UseUpdateSessionVariables>({
    mutationFn: ({ sessionId, resourceOwnerId, updates }) =>
      sessionService.updateSession(sessionId, updates, { resourceOwnerId }),
    onSuccess: (record) => {
      queryClient.setQueryData(
        sessionQueryKeys.detail(record.session_id),
        record,
      );
      // Sessions appear in three list mount points (top-level Sessions
      // page, dataset detail, device detail); invalidating `lists()`
      // keeps stale names from lingering across navigations.
      void queryClient.invalidateQueries({
        queryKey: sessionQueryKeys.lists(),
      });
    },
  });
}
